<template>
  <div>
    <template v-if="total">
      <div class="a-tab__title-block">
        <h3>{{$t('form.lot.total')}}</h3>
      </div>
      <div class="table-tab u-padding-b-24 a-width-300" >
        <div class="table-tab__container">
          <table class="table-tab__block table table-short">
            <thead class="table-tab__thead">
            <tr>
              <th class="u-text-left">
                <span v-t="lot.currency.label"></span>
                <img class="table-tab__img-help" src="@/assets/img/static/info.svg" alt="">
              </th>
              <td>{{total | price}}</td>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      lot: {
        type: Object,
        required: true
      }
    },

    computed: {
      total() {
        if (this.lot.currency.valueOf() === this.enums.Currency.EMPTY) {
          return
        }

        let isFull = true;

        const total = this.lot.specs.reduce((acc, spec) => {
          if (!spec.price) {
            isFull = false;
          }
          acc += (spec.price * spec.count) || 0;
          return acc;
        }, 0);

        return isFull ? total : undefined;
      },
    }
  }
</script>

<style scoped>

</style>
